import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { AlertTriangle, Snowflake, Wallet } from "lucide-react";
import { isSuperAdmin } from "../utils/auth";
import { getWallet } from "../apis/wallet";
import { fmtINR } from "../utils/money";

const REFRESH_MS = 120000;

/**
 * Global wallet warning banner:
 * - balance ≤ 0            → red hard-block banner (sends will fail)
 * - wallet frozen          → blue banner
 * - balance < threshold    → amber low-balance banner
 */
const WalletBalanceBanner = () => {
  const [wallet, setWallet] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (!isSuperAdmin()) return undefined;
    let cancelled = false;
    const load = () =>
      getWallet()
        .then((res) => { if (!cancelled && res.data?.success) setWallet(res.data.data); })
        .catch(() => {});
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, [location.pathname]);

  if (!wallet || location.pathname === "/wallet") return null;

  let tone = null;
  let icon = null;
  let text = null;

  if (wallet.status === "frozen") {
    tone = "blue";
    icon = <Snowflake size={16} />;
    text = "Your wallet is frozen — message sending is blocked. Contact support.";
  } else if (wallet.balance < 0) {
    tone = "red";
    icon = <AlertTriangle size={16} />;
    text = `Wallet is overdrawn ${fmtINR(wallet.balance)} from messages already delivered. Recharge to clear this and resume sending.`;
  } else if (wallet.balance <= 0) {
    tone = "red";
    icon = <AlertTriangle size={16} />;
    text = "Wallet balance exhausted — messages will not be sent until you recharge.";
  } else if (wallet.balance < wallet.low_balance_threshold) {
    tone = "amber";
    icon = <Wallet size={16} />;
    text = `Low wallet balance: ${fmtINR(wallet.balance)}. Recharge soon to avoid interruptions.`;
  }

  if (!tone) return null;

  return (
    <div className={`ping-banner ${tone}`} style={{ margin: 0, borderRadius: 0 }}>
      {icon}
      <div style={{ flex: 1 }}>
        <b>{text}</b>
      </div>
      {wallet.status !== "frozen" && (
        <Link to="/wallet" className="ping-btn ping-btn-primary ping-btn-sm">
          Recharge now
        </Link>
      )}
    </div>
  );
};

export default WalletBalanceBanner;
